// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetDebitTypes = state =>
    KeyValuePairCollection.update(state, {
        $set: getDefaultState().debitTypes
    });

const updateDebitTypes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().debitTypes, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_CLAIM_DEBIT]: resetDebitTypes,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_TYPES]: updateDebitTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/debit-types.js